import { Box, Button, IconButton, Typography } from '@mui/material'
import EastIcon from '@mui/icons-material/East';
import ClearIcon from '@mui/icons-material/Clear';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setLimitAlert } from '../../../../store/one-query/chatsSlice';
import { useEffect } from 'react';
import "../get-conversation/Popups.css"
import { useMethodHelper } from '../../../../store/one-query/useMethodHelper';

interface LimitAlertProps {
  message:string,
  btnMsg:string,
  btnAction?: string;
}

export const LimitAlert = ({message,btnMsg,btnAction}:LimitAlertProps) => {
  const dispatch = useAppDispatch();
  const limitAlert = useAppSelector((s) => s.ChatsState.limitAlert);
  const isSubscribed = useAppSelector((s) => s.User.isSubscribed);
  const [header, desc] = message?.split('!', 2);
  const executeAction = useMethodHelper();

  const handleCloseLimitAlert = () => {
    dispatch(setLimitAlert({show:false,message:'',btnTitle:''}),)
  }

  useEffect(() => {
    if (limitAlert.show) {
      const timer = setTimeout(() => {
        handleCloseLimitAlert();
      }, 40000);

      return () => clearTimeout(timer);
    }
  }, [limitAlert.show]);

  const handelBtnAction = () => {
    if(btnAction)
      executeAction(btnAction);
    handleCloseLimitAlert();
  }

  return (
    <Box className='limit-alert' sx={{
      '@media (max-width: 990px)':{
          width: '95%',
          bottom: '115px'
        },
        '@media (max-width: 620px)':{
          flexDirection:'column',
          alignItems:'flex-start',
          gap:'1rem',
          borderRadius:'16px'
        }
        }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', width: btnAction ? "70%" : "100%" }}>
        <Typography className='alert-header'>{header + '!'}</Typography>
        <Typography className='alert-desc'>{desc}</Typography>
      </Box>
      <Box sx={{display:'flex',
        alignItems:'center',
        flexDirection:'row', 
        gap:'8px',
        '@media (max-width: 620px)':{
            width: "100%",
            justifyContent: "space-between",
          },
        }}
      >
        { btnAction &&btnAction.length>0&&(
          <Button
            variant="contained"
            endIcon={<EastIcon />}
            sx={{
              backgroundColor: "#12B6EA",
              borderRadius: "22px",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: "700",
            }}
            onClick={handelBtnAction}
          >
            {btnMsg}
          </Button>
        )}
        <Box>
            <IconButton aria-label="delete" size="small" >
              <ClearIcon color='action' sx={{cursor:'pointer',textWrap:'none'}} onClick={handleCloseLimitAlert}/>
          </IconButton>
        </Box>
      </Box>
    </Box>
  )
}
